import * as React from "react";
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var ARGUMENT_NAMES = /([^\s,]+)/g;
function args(func) {
    var fnStr = func.toString().replace(STRIP_COMMENTS, '');
    var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
    var rStr = "return\\s*" + result[0] + ".([^;\}]*)";
    var findRet = new RegExp(rStr, "mg");
    var res = findRet.exec(fnStr);
    if (res)
        return res[1].split(".");
    return [];
}
function getPath(func1) {
    return args(func1);
}
var TypeRendererRegistry = /** @class */ (function () {
    function TypeRendererRegistry() {
        this._renderMap = {};
    }
    TypeRendererRegistry.prototype.getRenderer = function (func) {
        var _a, _b;
        var typename = getPath(func)[0];
        return ((_b = (_a = this._renderMap[typename]) === null || _a === void 0 ? void 0 : _a.default) !== null && _b !== void 0 ? _b : (function (props) { return React.createElement("div", null, "no renderer for " + typename + " found!"); }));
    };
    TypeRendererRegistry.prototype.registerRenderer = function (func, renderer) {
        var typename = getPath(func)[0];
        if (!this._renderMap[typename])
            this._renderMap[typename] = { default: renderer };
        else {
            var rm = this._renderMap[typename];
            if (rm) {
                if (rm.default)
                    console.warn("Renderer for type " + typename + " was already registered...");
                rm.default = renderer;
            }
        }
    };
    TypeRendererRegistry.prototype.getRendererWithName = function (name, func) {
        var typename = getPath(func)[0];
        var rm = this._renderMap[typename];
        var r = rm ? rm[name] : undefined;
        return (r !== null && r !== void 0 ? r : (function (props) { return React.createElement("div", null, "no renderer for " + typename + " found!"); }));
    };
    TypeRendererRegistry.prototype.registerRendererWithName = function (name, func, renderer) {
        var typename = getPath(func)[0];
        if (!this._renderMap[typename])
            this._renderMap[typename] = { default: renderer };
        else {
            var rm = this._renderMap[typename];
            if (rm) {
                if (rm[name])
                    console.warn("Renderer for type " + typename + " was already registered...");
                rm[name] = renderer;
            }
        }
    };
    return TypeRendererRegistry;
}());
export { TypeRendererRegistry };
